import { useMemo } from 'react';
import { useSupplierReports } from '../../../hooks/useSupplierLedger';
import { hasReportAmount } from '../utils/supplierLedgerHelpers';

const useSupplierReportsData = (filters = {}) => {
  const apiFilters = useMemo(
    () => Object.fromEntries(Object.entries(filters).filter(([, value]) => value !== '')),
    [filters],
  );
  const providerReport = useSupplierReports('by-provider', apiFilters);
  const conceptReport = useSupplierReports('by-concept', apiFilters);
  const classificationReport = useSupplierReports('by-classification', apiFilters);

  const providerRows = useMemo(
    () => (providerReport.data || []).filter(hasReportAmount),
    [providerReport.data],
  );
  const conceptRows = useMemo(
    () => [...(conceptReport.data || [])].sort((left, right) => (
      Number(right.total_amount_ars || 0) - Number(left.total_amount_ars || 0)
    )),
    [conceptReport.data],
  );
  const classificationRows = useMemo(
    () => [...(classificationReport.data || [])].sort((left, right) => (
      Number(right.pending_amount_ars || 0) - Number(left.pending_amount_ars || 0)
      || Number(right.total_amount_ars || 0) - Number(left.total_amount_ars || 0)
    )),
    [classificationReport.data],
  );

  return {
    providerRows,
    conceptRows,
    classificationRows,
    providerLoading: providerReport.isLoading || (providerReport.isFetching && !providerReport.data),
    conceptLoading: conceptReport.isLoading || (conceptReport.isFetching && !conceptReport.data),
    classificationLoading: classificationReport.isLoading || (classificationReport.isFetching && !classificationReport.data),
  };
};

export default useSupplierReportsData;
